import { render, staticRenderFns } from "./ScaniaDisplayMessage.vue?vue&type=template&id=35ddbcb0&"
import script from "./ScaniaDisplayMessage.vue?vue&type=script&lang=js&"
export * from "./ScaniaDisplayMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports